/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Component which gives the node ability to be dragged by mouse or touch. */
@cc._decorator.ccclass
export default class DraggableComponent extends cc.Component
{
    /** Target node to move. */
    @property(cc.Node)
    protected moveTarget: cc.Node = null;

    @property(cc.Float)
    protected moveDampner: number = 0.0;

    /** @hidden */
    protected onLoad(): void
    {
        this.node.on(cc.Node.EventType.TOUCH_MOVE, this.touchMoveHandler);

        if (!this.moveTarget) { this.moveTarget = this.node; }
    }

    /** Hander for touch move event. */
    private touchMoveHandler = (event: cc.Event.EventTouch): void =>
    {
        this.moveHandler(event.getDelta());
    }

    /** Handler for generic move. */
    private moveHandler = (delta: cc.Vec2): DraggableComponent =>
    {
        this.moveTarget.position = this.moveTarget.position.add(delta.sub(delta.mul(this.moveDampner)));
        return this;
    }
}
